import Button from '@doordash/component-button'
import { Text, InlineChildren, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import * as events from '../../../events'
import { CheckrStatus, ShippingStatus } from '../../../models/types'
import { loadUrl } from '../../../webview'
import ActivationKitModal from '../../molecules/activation-kit-modal'
import { detectWebviewOs } from '../../../utilities/userAgent'
import { OsTypes } from '../../../webview/types'
import { activation } from './strings'

const {
  shippedText,
  beingPreparedText,
  futureMessage,
  pastMessage,
  pastMessageWithDate,
  statusLabel,
  statusInProgress,
  expectedDeliveryDateLabel,
  trackButton,
  activationKitModalButton,
} = activation

type ActivationKitStepProps = {
  address: string
  shippingUrl: string
  shippingArrivalDate: string
  shippingStatus: ShippingStatus
  isActive: boolean
  isComplete: boolean
  bgcheckStatus: CheckrStatus
  trackConfirmationPageClick?: (name: string, data?: object) => Promise<any>
}
type ActivationKitStepState = {
  isShowingModal: boolean
}

const getShippedCopy = (
  bgcheckStatus,
  shippingStatus,
  active,
  complete,
  address,
  date
) => {
  // Future message
  if (bgcheckStatus !== CheckrStatus.Clear || (!active && !complete)) {
    // tslint:disable-next-line:max-line-length
    return futureMessage(address)
  }

  // Past Message
  if (shippingStatus === ShippingStatus.Delivered || complete) {
    return date ? pastMessageWithDate(address, date) : pastMessage(address)
  }

  // Active and package is shipped
  if (shippingStatus === ShippingStatus.Shipped && active && !complete) {
    return shippedText(address)
  }

  // Being Prepared
  return beingPreparedText(address)
}

class ActivationKitStep extends React.Component<
  ActivationKitStepProps,
  ActivationKitStepState
> {
  public state = {
    isShowingModal: false,
  }

  public toggleModal(e) {
    e.stopPropagation()

    const isShowingModal = !this.state.isShowingModal

    this.setState({
      isShowingModal,
    })
  }
  public render() {
    const {
      isActive,
      isComplete,
      address,
      shippingArrivalDate,
      bgcheckStatus,
      shippingStatus,
      trackConfirmationPageClick,
      shippingUrl,
    } = this.props

    const os = detectWebviewOs()
    const isWebview = os !== OsTypes.NONE

    return (
      <StackChildren>
        <Text style={Text.Styles.SectionSubtext}>
          {getShippedCopy(
            bgcheckStatus,
            shippingStatus,
            isActive,
            isComplete,
            address,
            shippingArrivalDate
          )}
        </Text>
        {shippingStatus === ShippingStatus.Shipped && (
          <div>
            {!isComplete && (
              <Text>
                {`${statusLabel()}: `}
                <Text
                  display={Text.DisplayModes.Inline}
                  weight={Text.Weights.Bold}
                >
                  {statusInProgress()}
                </Text>
              </Text>
            )}
            {shippingArrivalDate && !isComplete && (
              <Text>
                {`${expectedDeliveryDateLabel()} `}
                <Text
                  display={Text.DisplayModes.Inline}
                  weight={Text.Weights.Bold}
                >
                  {shippingArrivalDate}
                </Text>
              </Text>
            )}
          </div>
        )}
        <InlineChildren>
          {shippingUrl && (
            <Button
              type={Button.Types.SecondaryPill}
              size={Button.Sizes.Small}
              href={shippingUrl}
              tag="a"
              onClick={e => {
                if (isWebview) {
                  e.preventDefault()
                  loadUrl(shippingUrl)
                }
                e.stopPropagation()
              }}
              isInline
            >
              {trackButton()}
            </Button>
          )}
          <Button
            onClick={e => {
              trackConfirmationPageClick('activation_kit_button')
              this.toggleModal(e)
            }}
            type={Button.Types.FlatPrimary}
            size={Button.Sizes.Small}
            padding={Button.Padding.None}
            isInline
          >
            {activationKitModalButton()}
          </Button>
        </InlineChildren>
        {this.state.isShowingModal && (
          <ActivationKitModal
            onClose={e => {
              this.props.trackConfirmationPageClick(
                'activation_kit_modal_close'
              )
              this.toggleModal(e)
            }}
          />
        )}
      </StackChildren>
    )
  }
}

const mapDispatchToProps = {
  trackConfirmationPageClick: events.trackConfirmationPageClick,
}
export default connect(null, mapDispatchToProps)(ActivationKitStep)
